
















import { defineComponent, onUnmounted } from '@vue/composition-api'
import HeaderPane from '@/components/pc/common/Header/HeaderPane.vue'
import RewardPane from '@/components/RewardPage/RewardPane.vue'
import useRewards from '@/store/hook/videoPlatformContents/useRewards'

export default defineComponent({
  name: 'RewardPage',
  components: { RewardPane, HeaderPane },
  setup() {
    const { clearRewards } = useRewards()

    onUnmounted(() => {
      clearRewards()
    })
  },
})
